/** detect-gpu 的检测结果；在结果返回前为 null，此时不会创建 WebGL Canvas。 */
import { TierResult } from 'detect-gpu';
import { atom, useRecoilState } from 'recoil';

// WebGL 根据 tier、fps、移动端标记决定是否启用昂贵的后处理效果。
const gpuState = atom<TierResult | null>({
    key: 'gpuState',
    default: null,
});

export const useGpuState = () => useRecoilState(gpuState);
